import i18n from '@/i18n'; /*
 * @Author: TigerLord
 * @Date: 2022-09-06 15:30:55
 * @LastEditTime: 2022-09-26 14:00:15
 * @LastEditors: your name
 * @Description: 功能说明：——
 * @FilePath: /ytzx-console/src/pages/statis/WanjinyouBill/index.ts
 */
import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: true,
    resourceName: '公司订单查询',
    routerUrl: '/CompanyOrder',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./CompanyOrder')),
    // children: [
    //   {
    //     needLogin: true,
    //     resourceName: i18n.t('WanjinyouBill-index-1992f2b884097800b-2'),
    //     routerUrl: '/WanjinyouBillForm',
    //     resourceIcon: '',
    //     type: '2',
    //     buttons: [],
    //     component: loadable(() => import('./CompanyOrderForm')),
    //   },
    //   //$MORE$
    // ],
  },
];
